import { fetchCurrentReading } from './reading.api';
import { resolveReadingPagePreviewUrl } from './readingPagePreviewCache';

/** Warm JS chunk + reading JSON + page image so the book can paint on first click. */
export function prefetchReadingComprehensionExperience(): void {
  void import('../../pages/student/ReadingComprehension');
  void fetchCurrentReading()
    .then((payload) => {
      const previewUrl = payload.page_preview?.url;
      if (previewUrl) {
        void resolveReadingPagePreviewUrl(previewUrl);
      }
    })
    .catch(() => {
      /* warmup is best-effort */
    });
}
